import { Box, CheckBox, FormField, Grid, ResponsiveContext, Select, Text, TextInput } from "grommet";
import * as React from "react";
import ThemeBuilder from "../components/ThemeBuilder";
import { useReferenceData } from "../reference/ReferenceStore";
import LeagueLogoPicker from "./LeagueLogoPicker";
import LeagueSplashPicker from "./LeagueSplashPicker";
import { LeagueViewModel } from "./LeaguesStore";

const LeagueDetails = ({ league, isBusy, onChange }: { league: LeagueViewModel; isBusy: boolean; onChange: Function }) => {
    const [name, setName] = React.useState(league.name || "");
    const [isPublic, setIsPublic] = React.useState(league.isPublic || false);

    const [logoUri, setLogoUri] = React.useState(league.logoUri || "");
    const [splashUri, setSplashUri] = React.useState(league.splashUri || "");

    const [color, setColor] = React.useState(league.color || "");

    const [logoContent, setLogoContent] = React.useState("");
    const [splashContent, setSplashContent] = React.useState("");

    React.useEffect(() => {
        onChange({ name, logoUri, logoContent, splashUri, splashContent, color, isPublic });
    }, [name, logoUri, logoContent, splashUri, splashContent, color, isPublic]);

    const size = React.useContext(ResponsiveContext);

    React.useEffect(() => {
        if (league.logoUri && logoUri != league.logoUri) {
            setLogoUri(league.logoUri);
        }
        if (league.splashUri && splashUri != league.splashUri) {
            setSplashUri(league.splashUri);
        }
    }, [league.logoUri, league.splashUri]);

    const handleLogoChange = ({ uri, content }) => {
        if (content) {
            setLogoContent(content);
            setLogoUri("");
        } else if (uri) {
            setLogoUri(uri);
            setLogoContent("");
        }
    };

    const handleSplashChange = ({ uri, content }) => {
        if (content) {
            setSplashContent(content);
            setSplashUri("");
        } else if (uri) {
            setSplashUri(uri);
            setSplashContent("");
        }
    };

    return (
        <div>
            <>
                <Box>
                    <Grid columns={size == "small" ? ["auto"] : ["1/2", "1/2"]}>
                        <Box>
                            <FormField label="Name">
                                <TextInput value={name} onChange={(e) => setName(e.target.value)} disabled={isBusy} />
                            </FormField>
                            <FormField label="Public">
                                <CheckBox checked={isPublic} onChange={(e) => setIsPublic(e.target.checked)} disabled={isBusy} />
                            </FormField>
                        </Box>
                        <Box></Box>
                        <Box fill={true}>
                            <LeagueLogoPicker uri={logoUri} onSelect={handleLogoChange}></LeagueLogoPicker>
                        </Box>
                        <Box fill={true}>
                            <LeagueSplashPicker uri={splashUri} onSelect={handleSplashChange}></LeagueSplashPicker>
                        </Box>
                    </Grid>
                    <ThemeBuilder uri={logoUri} color={color} onSelect={(color) => setColor(color)}></ThemeBuilder>
                </Box>
            </>
        </div>
    );
};

export default LeagueDetails;
